import { toast } from "react-toastify";
import { LOGIN, FORGOT_PASSWORD, RESET_PASSWORD} from "../action/constant";

const initialState = {
  loading:false,
  err:{},
  buildingDaga:{},
}

export default function loginReducer(state = initialState,action){
  switch (action.type) {
    case LOGIN.PENDING:
      return {
        ...state,
        loading:true,
        err:{},
      }
     case LOGIN.SUCCESS:
       return {
         ...state,
         loading:false,
         err:{},
       }
    case LOGIN.ERROR:
      return {
        ...state,
        loading:false,
        err:action.err,
      }
      case FORGOT_PASSWORD.PENDING:
        return {
          ...state,
          loading:true,
          err:{},
        }
      case FORGOT_PASSWORD.SUCCESS:
        toast.success('Change Password link has send to your login Email.');
        return {
          ...state,
          loading:false,
          err:{},
        }
      case FORGOT_PASSWORD.ERROR:
        toast.error('Please provide correct login email')
        return {
          ...state,
          loading:false,
          err:{},
        }
      case RESET_PASSWORD.PENDING:
        return {
          ...state,
          loading:true,
          err:{},
        }
      case RESET_PASSWORD.SUCCESS:
        toast.success('Your password change successfully. Please login again')
        return {
          ...state,
          loading:false,
          err:{},
        }
      case RESET_PASSWORD.ERROR:
        toast.error('Error while updating password')
        return {
          ...state,
          loading:false,
          err:action.err,
        }
    default:
     return state;
  }

}

